import { EnumLang, EnumChatScene } from '@/src/pages/customer_service/lib/constant';
import { getCSDomainHost } from '@/src/utils/host';
import { $get, $post } from '../request';
import { ICreatFormParams, IRepeatCase } from '../type';

// 根据环境获取客服 host
export const getPageHost = () => getCSDomainHost();

export const Stringify = (value: any) => {
  try {
    return JSON.stringify(value);
  } catch (error) {
    return '';
  }
};

export async function init(params: {
  appkey: string;
  language: EnumLang;
  // 直进订单场景
  orderId?: string | undefined;
  // 直进会话场景
  chatId?: string;
  // 直进会话场景
  chatScene?: EnumChatScene;
  ext?: string;
  visitid?: string;
  bizline?: string;
}): Promise<Api.ApiResult<Model.IInitResponse>> {
  const host = getPageHost();
  const paramsString = Object.keys(params || {})
    .filter((key) => params?.[key])
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params?.[key] || '')}`)
    .join('&');

  const [, res] = await $get({
    url: `${host}/api/init?${paramsString}`,
  });
  return res;
}

export async function initOrder(params: { orderId: string; orderHelperScene?: number; visitId?: string; bizline?: string; }) {
  const host = getPageHost();
  const {
    orderId,
    orderHelperScene,
    visitId,
    bizline
  } = params || {};
  const [, res] = await $get({
    url: `${host}/api/init/order?orderId=${orderId}&orderHelperScene=${orderHelperScene}`,
    headers: {
      visitid: visitId,
      bizline,
    },
  });
  return res;
}

export async function getOrderList(params: {
  pageSize: number;
  pageNo: number;
  lastOrderId?: string;
  visitId?: string;
  cursorMap?: string;
}) {
  const {
    pageSize, pageNo, lastOrderId, visitId, cursorMap
  } = params || {};
  const host = getPageHost();
  const url = `${host}/api/order`;
  // if (lastOrderId) {
  //   url += `&lastOrderId=${lastOrderId}`;
  // }
  // if (cursorMap) {
  //   const cursor = JSON.stringify(cursorMap)
  //   url += `&cursorMap=${cursor}`;
  // }
  const res = await $get({
    url,
    data: {
      cursorMap: Stringify(cursorMap),
      pageSize,
      pageNo,
      lastOrderId,
    },
    headers: {
      visitid: visitId,
    },
  });
  return res;
}

// 二级页重构新增
export async function getFaqList(faqSearchKey: string, visitId, bizline?) {
  const host = getPageHost();
  const [, res] = await $get({
    url: `${host}/api/faq/faqList?faqSearchKey=${encodeURIComponent(faqSearchKey)}`,
    headers: {
      visitid: visitId,
      bizline,
    },
  });
  return res;
}

export async function getFaqAnswer(faqSearchKey: string) {
  const host = getPageHost();
  const [, res] = await $get({
    url: `${host}/api/faq/detail?faqSearchKey=${encodeURIComponent(faqSearchKey)}`,
  });
  return res;
}

/**
 * 识别是否在24小时内有已提交过待处理的迟滞工单（按照小时可配置）
 * [查询重复工单](https://a.sankuai.com/index/#/papi/project/14713e6f-f28a-47f5-953c-bbe9edc3fa78?apiId=37a2d6d7-da9d-4b7c-9c96-b6e847572bfe)
*/
export async function getWorkOrderSubmitStatus(orderId?: string, visitId?: string, bizline?: string): Promise<IRepeatCase> {
  const host = getPageHost();
  const [, res]: any[] = await $get({
    url: `${host}/api/form/repeatCase?orderId=${orderId}`,
    headers: {
      visitid: visitId,
      bizline,
    },
  },);
  return res;
}

export async function submitEvaluation(params) {
  const host = getPageHost();
  const [, res] = await $post({
    url: `${host}/api/faq/evaluate`,
    data: {
      ...(params || {})
    },
  });
  return res;
}

/**
 * 自动化退赔判责接口
*/
export async function getAutoRefundJudgeInfo(params: any, orderRegion?: string): Promise<any> {
  const host = getPageHost();
  const [, res] = await $post({
    url: `${host}/csapi/getAutoRefundJudgeInfo`,
    data: {
      ...(params || {}),
    },
    headers: {
      orderRegion
    },
  });
  return res || {};
}

// 二级页重构新增-服务进度页面
export async function fetchProgressData(params: { nextRecordsUrl: string; }, visitId: string) {
  const host = getPageHost();
  const paramsString = Object.keys(params || {})
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params?.[key] || '')}`)
    .join('&');
  const url = `${host}/api/form/list${paramsString ? `?${paramsString}` : ''}`;
  const res = await $get({
    url,
    headers: {
      visitid: visitId,
      'Sforce-Query-Options': 'batchSize=200',
    },
  });
  return res;
}

/**
 * 获取迟滞工单详情
*/
export async function getFormDetail(caseId: string, visitId: string, bizline?: string): Promise<ICreatFormParams> {
  const host = getPageHost();
  const [, res] = await $get({
    url: `${host}/api/form/detail?caseId=${caseId}`,
    headers: {
      visitid: visitId,
      bizline,
    },
  });
  return res as ICreatFormParams || {};
}

/**
 * D端骑手获取翻译地址接口
 */
export async function getTranslatedAddress(orderTranslateRequest: {
  sourceLanguage: string | undefined;
  contents: string[] | undefined;
}, visitId): Promise<any> {
  const host = getPageHost();
  const [, res] = await $post({
    url: `${host}/api/order/translate`,
    data: {
      ...(orderTranslateRequest || {}),
    },
    headers: {
      visitid: visitId,
    },
  });
  return res || null;
}

/**
 * 客服入口跳转D端异常上报页面
 */
export async function riderCanRedirectReport(params, orderRegion?: string): Promise<any> {
  const host = getPageHost();
  const [, res] = await $post({
    url: `${host}/csapi/courierReport/canRedirectReport`,
    data: {
      ...(params || {}),
    },
    headers: {
      orderRegion,
    },
  });
  return res || {};
}

/**
 * 获取未读消息数
 */
export async function getUnreadMsgCount(visitid): Promise<any> {
  const host = getPageHost();
  const [, res] = await $get({
    url: `${host}/api/message/getUnreadMsgCount`,
    headers: {
      visitid,
    },
  });
  return res;
}
